import { environment } from '@env/environment';

const { apiUrl } = environment;

/**
 * ### **CityEndpoint **
 *
 * Los endpoints son las URLs de un API o un backend que responden a una petición, en este caso las relacionadas a las ciudades.
 */
export class CityEndpoint {
  /** Endpoint que apunta a la información general de las ciudades.*/
  static cities = `${apiUrl}city-point/`;
  /** Endpoint que apunta a la información específica de de una ciudad*/
  static city = `${apiUrl}city-point/{}/`;
  /** Endpoint that points to the sidebar information of cities */
  static citiesSidebar = `${apiUrl}route/filter_weather_routes/`;
  /** Endpoint que apunta a la información de las valoraciones para una ciudad en especifico*/
  static cityValuations = `${apiUrl}city-point/{}/valuations/`;
  /** Endpoint que apunta a la información referente a la calificacion de una ciudad*/
  static qualificationsEdit = `${apiUrl}city-point/qualification/{}/`;
  /** Endpoint que recibe la información para agregar una calificación hecha por un usuario */
  static qualificationsAdd = `${apiUrl}city-point/qualification/`;
  /** Endpoint que retorna un json con la calificación de una ciudad hecha por un usuario*/
  static qualificationByUser = `${apiUrl}city-point/{}/qualification/by_user/{}/`;
  /** Endpoint que retorna la información de las valoraciones para una ciudad*/
  static valuations = `${apiUrl}city-point/valuations/{}/`;
  /** Endpoint que envia la valoración editada para una ciudad*/
  static valuationsEdit = `${apiUrl}city-point/valuations/{}/`;
  /** Endpoint que añade una valoración a una ciudad*/
  static valuationsRest = `${apiUrl}city-point/valuations/`;
  /** Endpoint que retorna la valoraciones de una ciudad hecha por un usuario*/
  static valuationsByUser = `${apiUrl}city-point/{}/valuations/by_user/{}/`;
  /** Endpoint that gets ratings info for a city */
  static cityInfoRatings = `${apiUrl}ubications/city/{}/city_ratings/`;
}
